export enum WIDGET_POST_LIST {
    /**
     * @value Back to posts list
     */
    BACK_TO_POSTS_LIST = 'COMMUNITY_POST.BACK_TO_POSTS_LIST',
    /**
     * @value Are you sure you want to delete this post?
     * @description The description message of the confirm dialog when you want to delete a post.
     */
    DELETE_CONFIRM_DESCRIPTION = 'COMMUNITY_POST.DELETE_CONFIRM_DIALOG_DESCRIPTION',
    /**
     * @value Delete post
     * @description The title of the confirm dialog when you want to delete a post.
     */
    DELETE_CONFIRM_TITLE = 'COMMUNITY_POST.DELETE_CONFIRM_DIALOG_TITLE',
    /**
     * @value Delete
     * @description This is the label of the button that allows the user to delete a post.
     */
    DELETE_POST = 'COMMUNITY_POST.DELETE_ACTION',
    /**
     * @value Discard share
     */
    DISCARD_SHARE = 'FRONT.COMMUNITY.POST.ACTION.UNSHARE',
    /**
     * @value Could not discard share.
     */
    DISCARD_SHARE_FAILURE = 'FRONT.COMMUNITY.POST.UNSHARED.FAILED',
    /**
     * @value The post has been unshared.
     */
    DISCARD_SHARE_SUCCESS = 'FRONT.COMMUNITY.POST.UNSHARED.SUCCESS',
    /**
     * @value Display post
     * @description The label of the button to open a post details page
     */
    DISPLAY_POST = 'COMMUNITY_POST.DISPLAY_ACTION',
    /**
     * @value Marked as relevant
     */
    FILTERS_AS_RELEVANT = 'COMMUNITY_POST.FILTERS_AS_RELEVANT',
    /**
     * @value Categories
     */
    FILTERS_CATEGORIES = 'WIDGET_POST_LIST.CATEGORIES',
    /**
     * @value Comments relevancy
     * @description Label of the comments relevancy filter in community post-list widget filters
     */
    FILTERS_COMMENTS_RELEVANCY = 'COMMUNITY_POST.FILTERS_COMMENTS_RELEVANCY',
    /**
     * @value Only reported
     */
    FILTERS_IS_REPORTED = 'COMMUNITY_POST.FILTERS_IS_REPORTED',
    /**
     * @value Not marked as relevant
     */
    FILTERS_NOT_AS_RELEVANT = 'COMMUNITY_POST.FILTERS_NOT_AS_RELEVANT',
    /**
     * @value Search for a post
     * @description Placeholder text for a text field
     */
    FILTERS_SEARCH_FOR_A_POST = 'COMMUNITY_POST.FILTERS_SEARCH_FOR_A_POST',
    /**
     * @value Sites
     * @description The label of the sites filters in the post-lis widget. Allow the users to chose a site to filter the posts by origin.
     */
    FILTERS_SITES = 'COMMUNITY_POST.FILTERS_SITES',
    /**
     * @value Post types
     * @description Label of the post types filter in the filters of the post-list widget.
     */
    FILTERS_TYPES = 'COMMUNITY_POST.FILTERS_POST_TYPES',
    /**
     * @value Move post
     * @description This is the label of the button that allows the user to move the post to another community.
     */
    MOVE_POST = 'COMMUNITY_POST.MOVE_ACTION',
    /**
     * @value Pinned
     * @description Pinned, as in a "pinned post" to put it in top of the list
     */
    PINNED = 'COMMUNITY_POST.PINNED',
    /**
     * @value Pinned by a community administrator
     */
    PINNED_BY_ADMIN = 'COMMUNITY_POST.PINNED_BY_ADMIN',
    /**
     * @value Pin this post
     * @description This is the label of the button that allows the user to pin the post.
     */
    PIN_POST = 'COMMUNITY_POST.PIN_ACTION',
    /**
     * @value You have reached the maximum number of pinned posts (%COUNT%). Unpin one or more posts before pinning a new one.
     */
    PIN_POST_COUNT_EXCEEDED_ERROR = 'COMMUNITY_POST.PIN_POST_COUNT_EXCEEDED_ERROR',
    /**
     * @value Post actions
     * @description The post actions button label, useful for accessibility, will be read by screen readers when the button is focused.
     */
    POST_ACTIONS_LABEL = 'COMMUNITY_POST.ACTIONS_BUTTON_LABEL',
    /**
     * @value Published a post
     */
    PUBLISHED_A_POST = 'POSTS.PUBLISHED_A_POST',
    /**
     * @value Published a post in %LOCATION%
     * @description Displayed when a post is published in a specific location.
     */
    PUBLISHED_A_POST_IN_LOCATION = 'POSTS.PUBLISHED_A_POST_IN_LOCATION',
    /**
     * @value Published a post in %LOCATION% with status %STATUS%
     * @description Displayed when a post is published in a specific location with a specific status.
     */
    PUBLISHED_A_POST_IN_LOCATION_WITH_STATUS = 'POSTS.PUBLISHED_A_POST_IN_LOCATION_WITH_STATUS',
    /**
     * @value Published a post with status %STATUS%
     * @description Displayed when a post has been created with a perticular status.
     */
    PUBLISHED_A_POST_WITH_STATUS = 'POSTS.PUBLISHED_A_POST_WITH_STATUS',
    /**
     * @value Shared with
     * @description Community posts can be shared with other communities. In several contexts we want to list the communities the post is shared with. (c.f. screenshots)
     */
    SHARED_WITH = 'FRONT.COMMUNITY.POST.SHARED_WITH',
    /**
     * @value Are you sure you want to unpin this post?
     * @description The description message of the confirm dialog when you want to unpin a post.
     */
    UNPIN_CONFIRM_DESCRIPTION = 'COMMUNITY_POST.UNPIN_CONFIRM_DIALOG_DESCRIPTION',
    /**
     * @value Unpin this post
     * @description The title of the confirm dialog when you want to unpin a post.
     */
    UNPIN_CONFIRM_TITLE = 'COMMUNITY_POST.UNPIN_CONFIRM_DIALOG_TITLE',
    /**
     * @value Unpin this post
     * @description This is the label of the button that allows the user to unpin a pinned post.
     */
    UNPIN_POST = 'COMMUNITY_POST.UNPIN_ACTION',
    /**
     * @value %USER% shared a post
     * @description Displayed when a user has shared a post.
     * The %USER% will be replaced by a link to the user profile.
     */
    USER_SHARED_A_POST = 'POSTS.USER_SHARED_A_POST',
    /**
     * @value %USER% shared a post in %LOCATION%
     * @description Displayed when a user has shared a post.
     * The %USER% will be replaced by a link to the user profile.
     * The %USER% will be replaced by a link to the user profile. %LOCATION% is replaced by a community name.
     *
     * example : Flora Barrande shared a post in "Human Ressources Community"
     */
    USER_SHARED_A_POST_IN_LOCATION = 'POSTS.USER_SHARED_A_POST_IN_LOCATION',
    /**
     * @value %USER% shared %DURATION%
     */
    USER_SHARED_FOR = 'COMMUNITY_POST.USER_SHARED_FOR',
    /**
     * @value The slideshow is not recommended for the community post list widget.
     */
    WARNING_MESSAGE_SLIDESHOW_VIEW = 'WIDGET_POST_LIST.WARNING_MESSAGE_SLIDESHOW_VIEW',
    /**
     * @value You shared a post
     * @description Displayed when a user has shared a post.
     * The %USER% will be replaced by a link to the user profile.
     */
    YOU_SHARED_A_POST = 'POSTS.YOU_SHARED_A_POST',
    /**
     * @value You shared a post in %LOCATION%
     * @description Displayed when a user has shared a post in a location (e.g. a community).
     * The %USER% will be replaced by a link to the user profile. %LOCATION% is replaced by a community name.
     *
     * example : You shared a post in "Human Ressources Community"
     */
    YOU_SHARED_A_POST_IN_LOCATION = 'POSTS.YOU_SHARED_A_POST_IN_LOCATION',
    /**
     * @value You shared %DURATION%
     */
    YOU_SHARED_FOR = 'COMMUNITY_POST.YOU_SHARED_FOR',
}

export const getPostPublicationTranslationKey = ({
    hasLocation,
    hasStatus,
}: {
    hasLocation: boolean;
    hasStatus: boolean;
}) => {
    if (hasLocation && hasStatus) {
        return WIDGET_POST_LIST.PUBLISHED_A_POST_IN_LOCATION_WITH_STATUS;
    }
    if (hasLocation) {
        return WIDGET_POST_LIST.PUBLISHED_A_POST_IN_LOCATION;
    }
    if (hasStatus) {
        return WIDGET_POST_LIST.PUBLISHED_A_POST_WITH_STATUS;
    }

    return WIDGET_POST_LIST.PUBLISHED_A_POST;
};
